/* @flow */

import type { JSON } from 'common/types';
import { failure } from 'common/json/extract';

export default function oneOf<Enum: JSON>(values: Array<Enum>): JSON => Enum {
  return (json: JSON) => {
    const index = values.indexOf(json);
    if (index !== -1) {
      return values[index];
    }
    return failure(
      `Expecting one of [${values.join(', ')}], got ${String(json)}`,
      () => values[0]
    );
  };
}
